import React from 'react';
import { useTranslation } from 'react-i18next';

import classes from './ChatHeader.module.css';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close-icon.svg';
import { ReactComponent as DownloadIcon } from '../../../assets/icons/download-icon.svg';


const ChatHeader = (props) => {
  const {t} = useTranslation('global');


  const button = props.isMobile ? '' : (
    <div className= {classes.HeaderButtons}>
      <button 
        className= {classes.CloseButton} 
        onClick={props.download}
        title={t('chatheader.download')} 
        aria-label={t('chatheader.download')}>
        <DownloadIcon/>
      </button>
      <button 
          className= {classes.CloseButton} 
          onClick={props.close}
          title={t('chatheader.close')} 
          aria-label={t('chatheader.close')}>
          <CloseIcon/>
      </button>
    </div>
  )


  return (
    <div className={classes.ChatHeader} role="region" aria-labelledby="chatHeaderTitle">
    <h3 id="chatHeaderTitle" className="sr-only"> {t('chatheader.title')} </h3>
      <div className={classes.HeaderAndLogo}>
        <div className= {classes.Logo}>
          <img src='https://iberia-omnichannel-eva.s3.eu-central-1.amazonaws.com/ibot/incono-iberia.png' alt= {t('chatheader.title')}/>
        </div>
        <div className= {classes.Title}>
          {t('chatheader.bot-name')}
        </div>
      </div>
      {button}
    </div>
  )
}



export default ChatHeader;